import { render, staticRenderFns } from "./imageUploadstu.vue?vue&type=template&id=6119e130"
import script from "./imageUploadstu.vue?vue&type=script&lang=js"
export * from "./imageUploadstu.vue?vue&type=script&lang=js"
import style0 from "./imageUploadstu.vue?vue&type=style&index=0&id=6119e130&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports